import { NoOwnerReason } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "内容入力",
  "対象施設一覧確認・異動状況登録",
  "入力内容確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "ex",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC050106_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "経営者でなくなった年月日",
    keyword: "noOwnerDate",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    helpText:
      "施設・事業を経営していた最後の日を入力してください。施設・事業の廃止によるものであれば、その廃止日を、吸収合併によるものであれば合併期日の前日を入力してください。",
  },
  {
    title: "経営者でなくなった理由",
    keyword: "noOwnerReason",
    type: "selectForm",
    selectPropsList: TkGetCodeList(NoOwnerReason),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "経営者でなくなった理由を選択してください。吸収合併の場合は「法人解散」を選択してください。",
  },
  {
    title: "理由",
    keyword: "reason",
    placeholder: "具体的な理由を入力してください",
    helpicon: true,
    helpText:
      "上記の「経営者でなくなった理由」欄がその他の場合、その理由を具体的に入力してください。",
    disabled: true,
    inputProps: { maxLength: 85 },
  },
  {
    title: "廃止・休止が確認できる書類の添付",
    keyword: "attachedFile",
    type: "fileUpload",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "経営者でなくなった証拠書類を添付してください。吸収合併等による法人解散が理由であれば合併契約書（写）を、施設・事業の廃止・休止が理由であれば、「廃止・休止届受理通知書」（写）、受理印等のある「廃止・休止届」（写）等を添付してください。",
  },
  {
    title: "変更後の共済契約者番号",
    keyword: "aContractorNo",
    inputProps: { maxLength: 6 },
    helpicon: true,
    helpText:
      "吸収合併または経営移管による施設の譲渡先（経営引継先）が当共済制度の契約者の場合は、譲渡先の共済契約番号（６ケタ）を入力してください。",
  },
  {
    title: "変更後の共済契約者名",
    keyword: "aCorpName",
    inputProps: { maxLength: 85 },
    helpicon: true,
    helpText:
      "吸収合併または経営移管による施設の譲渡先（経営引継先）が当共済制度の契約者の場合は、譲渡先の共済契約名称を入力してください。",
  },
];

const contextText = `入力された経営者でなくなった年月日の翌日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。
このまま契約解除の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されますがよろしいですか。`;

const schema = {
  noOwnerDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  noOwnerReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  reason: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  attachedFile: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  aContractorNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "6"),
    },
  },
  aCorpName: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { steps, fakeTableList, schema, contextText };
